import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.de'
import yieldLadder from './yieldLadder.de'

export default createLendingBundle({ whitepaper, yieldLadder })
